"use client";

import { useEffect } from "react";

export const ReviewsSection = () => {
  useEffect(() => {
    // Load EMR Pixel script
    const loadEMRPixel = () => {
      if ((window as any).EMRPixel) {
        console.info("EMR: Pixel already loaded");
        return;
      }

      const script = document.createElement("script");
      script.defer = true;
      script.src = `https://cdn2.revw.me/js/pixel.js?t=${Math.ceil(new Date().getTime() / 864e5) * 864e5}`;

      const firstScript = document.getElementsByTagName("script")[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.charset = "utf-8";
        firstScript.parentNode.insertBefore(script, firstScript);
      }

      script.onload = () => {
        if ((window as any).EMRPixel) {
          (window as any).EMRPixel.init("app.getcoucou.io", 20);
        }
      };
    };

    if (document.readyState === "interactive" || document.readyState === "complete") {
      loadEMRPixel();
    } else {
      document.addEventListener("DOMContentLoaded", loadEMRPixel);
    }

    return () => {
      document.removeEventListener("DOMContentLoaded", loadEMRPixel);
    };
  }, []);

  return (
    <div className="w-full  px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <h2 className="mb-12 font-cormorant text-4xl ph:text-5xl sm:text-6xl lg:mb-16 lg:text-7xl">
        AVIS
      </h2>
      <emr-simple-carousel widget-id="678d5439-2cc2-464e-9262-202dca45140b"></emr-simple-carousel>
    </div>
  );
};
